module.exports = __webpack_public_path__ + "img/trunk_4x1.7a19e44e.svg";